<template>
    <div :style="{ backgroundColor: homeImage.color ? homeImage.color : '#f3f4f6', height:'100vh', padding: '1% 1%', ...charteVars }">
        
        <!-- Wrapper pour contenir les éléments de la page -->
        <div class="homeWrapper">
            
            <!-- Image et texte superposé pour un effet moderne -->
            <div class="homeImage">
                <img :src="homeResource" alt="">
         
            </div>
            
            <!-- Espace pour une description ou un sous-titre (optionnel) -->
            <div class="homeDescription" :style="textStyle">
                <h4 v-html="processText(homeImage.text)"></h4>
            </div>
            
            <!-- Flèche animée pour inciter à l'action -->
            <div class="home-arrow" :style="launchStyle">
                <img v-if="launchImage" :src="launchImage" alt="" class="launchImage">
                <span @click="exitHomePage"><span v-html="processText(homeImage.launch_text)"></span><q-icon name="arrow_forward_ios"></q-icon></span>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { useRoute } from "vue-router";
import { useExhibitStyle } from "../../composables/useExhibitStyle";
import { useHomeLayout } from "../../composables/useHomeLayout";
export default {
    props: ["homeImage", "exhibitIdProps"],
    setup(props, ctx) {
        let homeResource = ref();
        const route = useRoute();
        const { cssVars, load: loadCharte } = useExhibitStyle(route.params.id ?? props.exhibitIdProps);
        const charteVars = computed(() => cssVars());
        const { textStyle, launchStyle } = useHomeLayout(() => props.homeImage);
        let exhibitId = ref();
        let launchResource = ref();
        let launchImage = ref();
        const start = async () => {
            console.log(props)
            exhibitId.value = route.params.id ?? props.exhibitIdProps;
            loadCharte();
            await getHomeFile();
            await getLaunchResource();
            if(launchResource.value?.launch_image_id) await getLaunchFile();
        };

        const processText = (text) => {
            if (!text) return text;
            return text.replace(/\\n/g, '\n');
        };

        const exitHomePage = () => {
            ctx.emit("exit");
        }

        const getHomeFile = async () => {
            try {
                setTimeout(async() => {
                    let name = props.homeImage.name;
                    let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                    let response = await axios.get(url);
                    var base64data = response.data;
                    homeResource.value = base64data;
                }, 500);
                
            } catch (error) {
                console.log(error);
            }
        };

       

        const getLaunchFile = async () => {
            try {
                let name = launchResource.value.name;
                let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
                let response = await axios.get(url);
                var base64data = response.data
                launchImage.value = base64data;
            } catch (error) {
                console.log(error);
            }
        };
        const getLaunchResource = async ( )=>{
            try {
                let url = `${process.env.VUE_APP_BASEURL}/launchImage/${exhibitId.value}`;
                let response = await axios.get(url);
                launchResource.value = response.data[0];

            } catch (error) {
                console.log(error);
            }
        }

        onMounted(start);

        return {
            homeResource,
            exhibitId,
            launchImage,
            launchResource,
            exitHomePage,
            processText,
            charteVars,
            textStyle,
            launchStyle

        }
    }

}
</script>
<style scoped>
.homeWrapper {
    max-width: 1200px; /* Limiter la largeur pour les grands écrans */
    margin: 0 auto; /* Centrer le wrapper */
    box-shadow: 0px 0px 35px rgba(0, 0, 0, 0.1); /* Ombre douce pour ajouter de la profondeur */
    padding: 1%;
    border-radius: 15px; /* Coins arrondis pour un aspect plus doux */
 
}

.homeImage {
    position: relative; /* pour superposer le texte */
}

.homeImage img {
    width: 100%;
    max-height: 50vh;
    object-fit: contain; /* Assurez-vous que l'image couvre toute la zone */
    border-radius: 10px; /* Coins arrondis */
}

.overlayText {
    position: absolute; 
    top: 50%; 
    left: 50%;
    transform: translate(-50%, -50%);
    color: white; 
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.6); 
}

.homeDescription {
    text-align: center;
    margin: 20px 0;
    font-size: 1.2rem;
    color: #555;
}

.homeDescription h4 {
    white-space: pre-line;
    font-size: var(--expo-title-size, 1.2rem);
    color: var(--expo-title-color, #555);
    font-family: var(--expo-title-font, inherit);
    font-weight: var(--expo-title-weight, bold);
}

.home-arrow {
    font-size: 25px;
    color: #333;
    cursor: pointer;
    text-align: center;
    animation-name: moveArrow;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    margin-top: 2%;
}

.home-arrow span {
    white-space: pre-line;
}

.launchImage{
    max-height: 100px;
    width: auto;
    object-fit: contain;
    background: transparent;
    margin-right: 8px;
}

@keyframes moveArrow {
    from {
        transform: translateX(-10px);
    }
    to {
        transform: translateX(10px);
    }
}
</style>